import { Wallet } from "./wallet.model";

export interface LoginDto {
  number: string;
  email: string;
  brand: string;
}

export interface LoginError {
  code: number;
  message: string;
}

export interface LoginSuccess {
  status: string;
  messages: string[];
  data: {
    wallet: Wallet;
    token: string;
  };
  metadata: any;
}

export type LoginResponse = LoginSuccess | LoginError;

export interface ActivateBraceletDto {
  code?: number;
  number: string;
  email: string;
  firstname: string;
  lastname: string;
  brand: string;
}

export interface LoginTicketDto {
  token: string;
  email: string;
  signature: string;
  brand: string;
  firstname?: string;
  lastname?: string;
}

export interface TicketCheckResponse {
  status: string;
  messages: string[];
  data: {
    signature: boolean;
    wallet_creation: boolean;
  };
}

export interface LoginErrorResponse {
  status: string;
  messages: LoginErrorMessage[];
}

export interface LoginErrorMessage {
  code: LoginErrorCodeEnum;
  field: string;
  message: string;
}

export enum LoginErrorCodeEnum {
  AUTH_ERR = "AUTH_ERR",
  AUTH_MAX_ATTEMPT = "AUTH_MAX_ATTEMPT",
}